// 9fbef606107a605d69c0edbcd8029e5d
import { getAPIConfig } from '@tcp/core/src/utils';
import logger from '@tcp/core/src/utils/loggerInstance';
import endpoints from '@tcp/core/src/services/endpoints';
import { executeStatefulAPICall } from '@tcp/core/src/services/handler/handler';

const Abstractor = {
  /**
   * Fetches size chart guide data.
   * @param {string} file - The file name for size chart data.
   * @returns {Promise<Object>} Promise that resolves to size chart data.
   */
  getSizeChartGuideData: async (file) => {
    try {
      const { brandId, sizeChartGuidePrefix, locale } = getAPIConfig();
      const sizeChartConfig = endpoints.getJsonURL(sizeChartGuidePrefix, brandId, file, locale);
      const timestamp = new Date().getTime(); // Generate timestamp
      const updatedUrl = {
        ...sizeChartConfig,
        URI: `${sizeChartConfig.URI}?t=${timestamp}`, // Append timestamp
      };
      const reqObj = {
        webService: updatedUrl,
        skipApiIdentifier: true,
      };

      const res = await executeStatefulAPICall(reqObj);

      if (!res?.ok || !res.body) {
        logger.error(`Failed to fetch Size chart data from ${updatedUrl.URI} for ${file} file`);
        throw new Error(`Failed to fetch Size chart data`);
      }

      return {
        ...res.body,
        timestamp,
      };
    } catch (error) {
      logger.error(`Error fetching Size Chart Data of ${file} -`, error);
      throw error;
    }
  },
};

export default Abstractor;
